module.exports = __webpack_public_path__ + "static/media/store-blu.71d749d4.svg";